import * as React from "react";
import {isCart, useUnsafeCartContext} from "./cart/CartContextProvider/CartContextProvider";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import window from "../components/lib/WindowExtended";
import {grey2} from "./theme";

const links = window.c_links;

const CartLink: React.FC = () => {
  const context = useUnsafeCartContext();
  const {t} = useTranslation();

  if (!isCart(context) || !context.isIntoCheckout) {
    return null;
  }

  return (
    <React.Fragment>
      <span
        onClick={() => {
          context.setIsIntoCheckout(false);
        }}
      >
        {t("Warenkorb")}
      </span>
      {" / "}
    </React.Fragment>
  );
};

const Footer: React.FC = () => {
  const {t} = useTranslation();

  return (
    <StyledFooter>
      <div>
        <CartLink />
        <a href={links.URL_Privacy} target="_blank" rel="noopener noreferrer">
          {t("Datenschutz")}
        </a>
        {" / "}
        <a href={links.URL_RevocationRights} target="_blank" rel="noopener noreferrer">
          {t("Widerruf")}
        </a>
        {" / "}
        <a href={links.URL_TermsAndConditions} target="_blank" rel="noopener noreferrer">
          {t("AGB")}
        </a>
        {" / "}
        <a href={links.URL_Imprint} target="_blank" rel="noopener noreferrer">
          {t("Impressum")}
        </a>
      </div>
      <strong>
        {t("Kundenberatung")} <a href={`tel:${links.ContactPhone.replace(/(\s|\(|\))/g, "")}`}>{links.ContactPhone}</a>
      </strong>
    </StyledFooter>
  );
};

const StyledFooter = styled.div`
  display: flex;
  justify-content: space-between;
  box-shadow: 0 40px 30px -35px inset rgba(0, 0, 0, 0.2);
  margin: 0;
  padding: 2rem;
  max-width: none;

  a,
  span,
  strong {
    color: ${grey2};
  }

  strong > a {
    cursor: pointer;
  }

  @media (max-width: 767px) {
    align-items: center;
    flex-direction: column;

    > * {
      padding-bottom: 1rem;
    }
  }
`;

export default Footer;
